import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/check-circle.svg'


const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = { class: "flex flex-col space-y-3" }
const _hoisted_3 = { class: "text-20px font-semibold text-black-lp-200" }
const _hoisted_4 = { class: "space-y-1" }
const _hoisted_5 = {
  key: 0,
  class: "space-y-2"
}
const _hoisted_6 = { class: "text-gray-lp-600 text-12px xxl:text-14px" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-5 mr-2",
  alt: "ok"
}, null, -1)
const _hoisted_8 = { class: "text-gray-lp-300 text-12px xxl:text-14px" }
const _hoisted_9 = { class: "flex justify-end space-x-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_LpButton = _resolveComponent("LpButton")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("img", {
        src: 
          require(`@/app/ui/assets/svg/${
            _ctx.sttNumberSuccessDelete ? 'delete-success' : 'delete-confirm'
          }.svg`)
        ,
        class: "w-40 mr-12",
        alt: "del"
      }, null, 8, ["src"]),
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("updateDelivery.deleteStt.title")), 1),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", {
            class: "text-12px xxl:text-14px text-gray-lp-600 pr-12",
            innerHTML: _ctx.$t('updateDelivery.deleteStt.message')
          }, null, 8, ["innerHTML"]),
          _createVNode(_component_LpInput, {
            ref: "deleteStt",
            error: _ctx.errorSttNumberDelete !== '',
            errorCaption: _ctx.errorSttNumberDelete,
            modelValue: _ctx.sttNumberToDelete,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.sttNumberToDelete = $event)),
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.errorSttNumberDelete = '')),
            onEnter: _ctx.onDeleteSttNumber
          }, null, 8, ["error", "errorCaption", "modelValue", "onEnter"])
        ]),
        (_ctx.sttNumberListTrash.length > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("updateDelivery.deleteStt.removed")), 1),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sttNumberListTrash, (item) => {
                return (_openBlock(), _createBlock("div", {
                  class: "flex flex-row",
                  key: item
                }, [
                  _hoisted_7,
                  _createVNode("div", _hoisted_8, _toDisplayString(item), 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode(_component_LpButton, {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close'))),
        customClass: "px-10 py-2",
        textColor: "red-lp-100",
        outline: "",
        title: _ctx.$t('updateDelivery.deleteStt.cancel'),
        class: "mt-10"
      }, null, 8, ["title"]),
      _createVNode(_component_LpButton, {
        disabled: _ctx.sttNumberToDelete === '',
        onClick: _ctx.onDeleteSttNumber,
        customClass: "px-10 py-2",
        textColor: "white",
        title: _ctx.$t('updateDelivery.deleteStt.delete'),
        class: "mt-10"
      }, null, 8, ["disabled", "onClick", "title"])
    ])
  ]))
}